import {useRef} from "react";

export const useInitOnce = <T>(init: () => T) => {
    const instance = useRef<T | undefined>(undefined);
    if (instance.current === undefined) {
        instance.current = init();
    }
    return instance.current;
}
